module.exports = __webpack_public_path__ + "static/media/icon-log-problem.b44ad01a.svg";